/**
 * Directive for a sticky nav element that will stick to the top of the page
 * instead of scrolling off of the page.
 *
 * @ngInject
 */
function StickyNavDirective($document, $window) {
  return {
    restrict: 'A',
    scope: {},
    bindToController: {
      disabled: '&?',
      scrollContainerId: '@?'
    },

    controller: require('./controller.js'),
    controllerAs: 'stickyNavCtrl',

    link: function(scope, el, attrs, controller) {
      // Check for an unstick button inside the element and attach a click
      // handler if there is one.
      var unstickButton = el[0].querySelector('.sticky-nav__unstick-button');
      if (unstickButton) {
        unstickButton.addEventListener('click', function() {
          scope.$apply(function() {
            controller.forceUnstick();
          });
        });
      }

      $window.addEventListener('resize', function() {
        scope.$apply(function() {
          controller.handleResize();
        });
      });

      var scrollContainer = controller.scrollContainerId ? $document[0].getElementById(controller.scrollContainerId) : $window;
      controller.scrollContainer = scrollContainer;

      if (scrollContainer) {
        scrollContainer.addEventListener('scroll', function() {
          scope.$apply(function() {
            controller.handleScroll();
          });
        });
      }

      var header = $document[0].getElementById('sitewide-header');
      if (header) {
        var updateMargin = function() {
          var headerHeight = header.offsetHeight;
          el.css('margin-top', headerHeight + 'px');
        };

        // Initial set
        updateMargin();

        // Observe header for size changes
        var resizeObserver = new ResizeObserver(updateMargin);
        resizeObserver.observe(header);

        // Cleanup
        scope.$on('$destroy', function() {
          resizeObserver.disconnect();
        });
      }
    }
  };
}

module.exports = StickyNavDirective;
